import {
  languageMap,
  type IMedium,
  type LanguageKey,
  type LinkComponent,
  type LinkComponentProps,
} from "@op/puck-types";
import { Button, DropdownMenu, Ow_Nav } from "@op/sf-op";
import {
  FeatherChevronDown,
  DropdownMenu as SfCDropdownMenu,
} from "@subframe/core";
import Medium from "../../../../../components/puck/Medium/Medium";
// @ts-ignore
import openpaperLogo from "../../../../../assets/openpaper-logo.svg?url&no-inline";

export const DefaultLinkComponent = ({
  to,
  children,
  ...props
}: LinkComponentProps) => {
  return (
    <a href={to} {...props}>
      {children}
    </a>
  );
};

const DEFAULT_LOGO_IMAGE = {
  src: openpaperLogo,
  alt: "OpenPaper Logo",
};

export interface ThemeNavProps {
  languageKey: string;
  languages: LanguageKey[];
  logoImage?: IMedium | null;
  organizationName?: string;
  organizationLink?: string;
  LinkComponent?: LinkComponent;
}

export const ThemeNav = ({
  languageKey,
  languages,
  logoImage,
  organizationName,
  organizationLink,
  LinkComponent = DefaultLinkComponent,
}: ThemeNavProps) => {
  return (
    <div className="w-full max-w-[1024px] fixed z-10 top-8 px-8">
      <Ow_Nav
        imageSlot={
          <LinkComponent
            to="/$languageKey"
            params={{ languageKey }}
            className="contents"
          >
            {logoImage ? (
              <div className="h-full w-auto text-default-font">
                <Medium noContainer cover medium={logoImage} />
              </div>
            ) : (
              <img
                src={DEFAULT_LOGO_IMAGE.src}
                alt={DEFAULT_LOGO_IMAGE.alt}
                className="h-full w-auto text-default-font"
              />
            )}
          </LinkComponent>
        }
        buttonSlot={
          <div className="flex flex-row items-center gap-4">
            {languages.length > 0 && (
              <SfCDropdownMenu.Root>
                <SfCDropdownMenu.Trigger asChild={true}>
                  <Button
                    variant="neutral-primary"
                    iconRight={<FeatherChevronDown />}
                  >
                    {languageMap[languageKey as LanguageKey]}
                  </Button>
                </SfCDropdownMenu.Trigger>
                <SfCDropdownMenu.Content
                  side="bottom"
                  align="start"
                  sideOffset={4}
                  asChild={true}
                >
                  <DropdownMenu>
                    {languages.map((language) => (
                      <LinkComponent
                        to="/$languageKey"
                        params={{ languageKey: language }}
                        className="contents"
                        key={language}
                      >
                        <DropdownMenu.DropdownItem icon={null}>
                          {languageMap[language as LanguageKey]}
                        </DropdownMenu.DropdownItem>
                      </LinkComponent>
                    ))}
                  </DropdownMenu>
                </SfCDropdownMenu.Content>
              </SfCDropdownMenu.Root>
            )}
            <a href={organizationLink} target="_blank" className="contents">
              <Button variant="neutral-primary">{organizationName}</Button>
            </a>
          </div>
        }
      />
    </div>
  );
};
